module.exports = __webpack_public_path__ + "img/072.e6e9d897.jpeg";